import { cn } from "@/lib/utils";
import type { Game } from "@/types/game";
import { Icon } from "@/components/ui/icon"
import {
  GameReceivedRatingSummary,
  type GameReceivedRatingData,
} from "@/components/games/GameReceivedRatingSummary";

type GameRatingsDoneCardProps = {
  summary?: Game["myTeammateRatingsSummary"];
  received?: GameReceivedRatingData | null;
  className?: string;
};

function getRatingsGivenDetail(
  summary: Game["myTeammateRatingsSummary"] | undefined,
): string | null {
  if (summary && summary.teammatesToRate > 0) {
    return `Você avaliou ${summary.ratingsGiven} de ${summary.teammatesToRate} colegas.`;
  }
  if (summary && summary.teammatesToRate === 0) {
    return "Sua avaliação deste jogo foi registrada.";
  }
  return null;
}

export function GameRatingsDoneCard({
  summary,
  received,
  className,
}: GameRatingsDoneCardProps) {
  const givenDetail = getRatingsGivenDetail(summary);
  const receivedFromSummary =
    summary && summary.ratingsReceivedCount > 0
      ? {
          ratingsCount: summary.ratingsReceivedCount,
          averageStars: summary.averageReceivedStars,
          effectiveSkill: summary.averageReceivedStars,
        }
      : null;
  const receivedData = received ?? receivedFromSummary;

  return (
    <div
      className={cn(
        "w-full bg-card-surface p-8 rounded-xl border border-card-border shadow-xl shadow-black/5 dark:shadow-none flex flex-col gap-4",
        className)}
    >
      <div className="flex items-start gap-4">
        <div className="w-11 h-11 rounded-full bg-amber-500/10 text-amber-600 shrink-0 flex items-center justify-center">
          <Icon name="star" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-text-muted text-sm font-medium mb-2">Avaliação</p>
          <p className="text-foreground text-xl font-bold">Avaliação já realizada</p>
          {givenDetail ? (
            <p className="text-text-muted text-sm mt-1">{givenDetail}</p>
          ) : null}
        </div>
      </div>

      {receivedData ? <GameReceivedRatingSummary {...receivedData} /> : null}
    </div>
  );
}
